// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-4eed5883],.fade-leave-active[data-v-4eed5883]{transition:opacity 0.3s}.fade-enter[data-v-4eed5883],.fade-leave-to[data-v-4eed5883]{opacity:0}.layout__container[data-v-4eed5883]{min-height:100vh}.layout__container .layout__content[data-v-4eed5883]{width:100%}.user-layout[data-v-4eed5883]{padding-top:5.56522rem}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
